var map = {
	"./blue/close.png": "./src/assets/image/blue/close.png",
	"./purple/close.png": "./src/assets/image/purple/close.png",
	"./red/close.png": "./src/assets/image/red/close.png",
	"./yellow/close.png": "./src/assets/image/yellow/close.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/close\\.png$";